import React, { Component } from 'react';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import './index.scss';
import {bgHeader} from "../../constants/theme";
import { Link } from 'react-router-dom';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <AppBar className="header" color={bgHeader} position="static" style={{height:59}}>
                <Toolbar>
                    <Typography type="title" color="inherit" className='flex'>
                        <Link to="/landing">
                            <img src='assets/logo.png' alt='logoHeader' className='logoHeader' />
                        </Link>
                    </Typography>
                    <div>
                        {/*<span>จำลองการติดตั้ง</span>*/}
                        {/*<span>เกี่ยวกับ</span>*/}
                    </div>
                </Toolbar>
            </AppBar>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/header/index.js